import { bodyBgGradient1 } from "./BodyBgStore";

export const updateBodyBgGradient1 = (value) => bodyBgGradient1.update(oldValue => value);
